import { themeColors } from "../theme/colors";
import burgerEmoji from "../assets/burger.png";
import moneyBagEmoji from "../assets/moneyBag.png";
import giftEmoji from "../assets/gift.png";
import palmTreeEmoji from "../assets/palmTree.png"
import houseEmoji from "../assets/house.png"

export const CATEGORIES = [
  { id: 0, name: "Foyer", emoji: burgerEmoji, color: themeColors.purpleLight, solidColor: themeColors.purpleLightSolid },
  { id: 1, name: "Sport", emoji: houseEmoji, color: themeColors.pink, solidColor: themeColors.pinkSolid },
  { id: 2, name: "Travail", emoji: moneyBagEmoji, color: themeColors.green, solidColor: themeColors.greenSolid },
  { id: 3, name: "Loisir", emoji: giftEmoji, color: themeColors.blue, solidColor: themeColors.blueSolid },
  { id: 4, name: "Bien-être", emoji: palmTreeEmoji, color: themeColors.yellow, solidColor: themeColors.yellowSolid }
];